import { render, staticRenderFns } from "./EdithCdss.vue?vue&type=template&id=a8e81cc8"
import script from "./EdithCdss.vue?vue&type=script&lang=js"
export * from "./EdithCdss.vue?vue&type=script&lang=js"
import style0 from "./EdithCdss.vue?vue&type=style&index=0&id=a8e81cc8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports